import { useMemo } from "react"

import { type VideoTag } from "@forento/shared/models/video"

import { useTranslation } from "~/translations"
import { getProductPriceLabel } from "~/utilities/product"
import { query } from "~/utilities/trpc"

type UseVideosResult =
	| { status: "error" | "loading" }
	| {
			status: "success"
			tags: VideoTag[]
			data: {
				id: number
				title: string
				thumbnailFilePath: string | null
				shortDescription: string | null
				tagIds: number[]
				priceLabel: { color: "orange" | "blue"; value: string }
			}[]
	  }
export function useVideos(): UseVideosResult {
	const t = useTranslation()

	const { data: tags, error: tagsError } = query.video.listTags.useQuery()
	const { data: videos, error: videosError } = query.video.listPersonalized.useQuery()

	return useMemo(() => {
		if (tagsError || videosError) return { status: "error" }
		if (tags === undefined || videos === undefined) return { status: "loading" }

		return {
			status: "success",
			tags,
			data: videos.map(video => ({
				id: video.id,
				title: video.title,
				thumbnailFilePath: video.thumbnailFilePath,
				shortDescription: video.shortDescription,
				tagIds: video.tags.map(t => t.id),
				priceLabel: getProductPriceLabel(video, t),
			})),
		}
	}, [tagsError, videosError, tags, videos, t])
}
